import { Entry } from "contentful";
import { ContentBlock, GuideTypes, Metadata, TipBox, TipBoxIconPositions } from "../models";
import { FieldMapping, UserContextValues } from "../types";
import { convertToHtmlString, findContent, parseIntoImage } from "../utils";

export const createTipBox = (
  fieldMapping: FieldMapping<TipBox>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): TipBox => {
  const content = findContent(entries, fieldMapping.text, guideType);
  const icon = findContent(entries, fieldMapping.icon, guideType);

  return {
    text: convertToHtmlString(content?.fields.richContent, userContextValues),
    icon: parseIntoImage(icon?.fields.richContent.content[0].data),
    iconPosition: fieldMapping.iconPosition as TipBoxIconPositions,
    heading: findContent(entries, fieldMapping.heading, guideType)?.fields.heading,
    buttonText: findContent(entries, fieldMapping.buttonText, guideType)?.fields.buttonText,
    buttonUrl: findContent(entries, fieldMapping.buttonText, guideType)?.fields.buttonUrl,
    subStep: fieldMapping.subStep as unknown as boolean,
  };
};
